import Dialog from '@mui/material/Dialog'

const JobPostActionSuccess = ({ successData, onClose }) => {
  return (
    <Dialog
      open={!!successData.open}
      onClose={onClose}
      scroll="body"
      fullWidth
      classes={{
        paper: 'md:!max-w-[420px] !p-[24px] !rounded-[12px] !bg-[#FEEBDD] !shadow-modal-light',
      }}
    >
      <div className="w-full flex flex-col items-center justify-start">
        <img src="/assets/icon/jobs-success.svg" alt="Success" className="w-[124px] h-[124px]" />

        <h2 className="text-xl font-bold text-primary-100 mt-[16px] text-center">
          {successData.title}
        </h2>

        <h3 className="text-sm font-medium text-primary-100 mt-[8px] text-center">
          {successData.description}
        </h3>

        <button
          className="mt-[24px] rounded-[8px] bg-primary-button hover:bg-primary-button-hover w-full h-[44px] shadow-button text-lg font-semibold text-white transition-colors duration-200 ease"
          onClick={onClose}
        >
          Continue
        </button>
      </div>
    </Dialog>
  )
}

export default JobPostActionSuccess
